/* eslint-disable no-undef */
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.

// Polyfill for IE11
import 'babel-polyfill';

import './logging';
import Vue from 'vue';
import App from './App';
import AuthHandler from './components/auth/AuthHandler';
import router from './router';
import i18n from './languages';
import vSelect from 'vue-select';
import VTooltip from 'v-tooltip';
import VueSlider from 'vue-slider-component';
import vmodal from 'vue-js-modal';
import Notify from 'vue2-notify';
import store from './store';
import Raven from 'raven-js';
import RavenVue from 'raven-js/plugins/vue';
import FiltersPlugin from './plugins/FiltersPlugin';
import VueAxios from 'vue-axios';
import VueScrollTo from 'vue-scrollto';
import { axiosInstance } from './api';

import 'vue-slider-component/theme/default.css';
import '@/components/general/VueSelect';

Vue.config.productionTip = false;

Vue.use(VTooltip);

Vue.use(vmodal);
Vue.use(AuthHandler);
Vue.use(FiltersPlugin);
Vue.component('VueSlider', VueSlider);

// Scroll to element with easing;
Vue.use(VueScrollTo);

// Default notifications configuration: vue2-notify
Vue.use(Notify, {
    itemClass: '',
    permanent: false,
    duration: 300,
    visibility: 5000,
    position: 'bottom-right'
});

const types = {
    info: { itemClass: 'toaster', iconClass: 'alert__icon mdi mdi-information' },
    error: { itemClass: 'toaster--error', iconClass: 'alert__icon mdi mdi-alert-circle' },
    warning: { itemClass: 'toaster--warning', iconClass: 'alert__icon mdi mdi-alert' },
    success: { itemClass: 'toaster--success', iconClass: 'alert__icon mdi mdi-checkbox-marked-circle' }
};

Vue.$notify.setTypes(types);

// Use config.json for production-like env and the <env_name>.json for other env;
const configFileName = process.env.NODE_ENV === 'production' ? 'config.json' : process.env.NODE_ENV + '.json';
axiosInstance.get('/static/' + configFileName).then(config => config.data)
    .then(config => {
        Vue.prototype.$config = config;
        Vue.prototype.$config.debug = process.env.NODE_ENV === 'development';

        // Set the baseURL according to the latest config and register the instance.
        axiosInstance.defaults.baseURL = Vue.prototype.$config.api.url;
        Vue.use(VueAxios, axiosInstance);

        connectRaven();
        connectAnalytics();

        new Vue({
            el: '#app',
            router,
            i18n,
            store,
            template: '<App/>',
            components: { App }
        });
    },
    err => console.log('No configuration fie provided.'));

// Error reporting configuration: Sentry + Raven
function connectRaven() {
    let config = Vue.prototype.$config;
    if (!config.debug && config.errorTracking && config.errorTracking.enabled) {
        Raven
            .config(config.errorTracking.url)
            .addPlugin(RavenVue, Vue)
            .install();
    }
}

function connectAnalytics() {
    let config = Vue.prototype.$config;
    if (!config.debug && config.analytics && config.analytics.enabled) {
        var VueAnalytics = require('vue-analytics');
        Vue.use(VueAnalytics, {
            id: config.analytics.id,
            router,
            debug: {
                enabled: true,
                trace: false,
                sendHitTask: true
            }
        });
    }
}



// WEBPACK FOOTER //
// ./src/main.js